import { Box, Grid, Typography, Button } from "@mui/material";
import { Gauge } from '@mui/x-charts/Gauge';

const POChart = ({ statusTabs, statusCounts, onShowTable }) => {
  return (
    <>
    <Box sx={{ 
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        p: 2 }}>
      <Grid container spacing={3}>
        {statusTabs.map((status) => (
          <Grid item xs={12} sm={4} key={status}>
            <Typography align="center">{status}</Typography>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <Gauge
                value={statusCounts.percentages[status]}
                valueMax={100}
                width={200}
                height={200}
                startAngle={-90}
                endAngle={90}
                innerRadius="70%"
                outerRadius="100%"
                sx={{
                  [`& .MuiGauge-valueArc`]: {
                    stroke: "#1976d2",
                  },
                  [`& .MuiGauge-valueText`]: {
                    fontSize: "1.4rem",
                  },
                }}
              />
            </Box>
             <Typography align="center" sx={{ mt: 1 }}>
                {statusCounts.counts[status]} records
              </Typography>
          </Grid>
        ))}
      </Grid>
    </Box>
      <Box textAlign="center" mt={4}>
        <Button variant="contained" onClick={onShowTable}>
          Show All Purchase Orders
        </Button>
      </Box>
      </>
  );
};

export default POChart;
